import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import PatientsListTable from './PatientsListTable';
import PatientInfoDisplay from './PatientsInfoDisplay/PatientInfoDisplay';
import ENDPOINTS, { API_BASE_URL } from '../../../Constants/ApiEndpoints';
import axios from 'axios';



const Patients = () => {

    const navigate = useNavigate();

    const { id } = useParams();
    const location = useLocation();
    const [patient, setPatient] = useState(location.state?.patient || null);
    const [loadingPatient, setLoadingPatient] = useState(!patient && !!id);

    const isPatientView = location.pathname.includes('/patientInfoDisplay/');


    useEffect(() => {
        const fetchPatientById = async () => {
            try {
                setLoadingPatient(true);
                setPatient(null); // clear previous patient before loading new one
                // const response = await fetch(`${ENDPOINTS.GET_APPOINTMENT_DETAILS_BY_APPOINTMENT_ID}/${id}`);
                const response = await axios.get(`${API_BASE_URL}/getPatientInfoDisplayData/${id}`);
            
                const patientAndAppointmentData = response.data;
                console.log('Fetched patient data by ID:', patientAndAppointmentData);
                setPatient(patientAndAppointmentData);

                 // Fetch payment & package history separately (optional)
            try {
                const invoicePaymentsPackageresponse = await axios.get(
                    `${API_BASE_URL}/getPatientPaymentHistory/${id}?patientType=OP`
                );
                const historyData = invoicePaymentsPackageresponse.data;
                console.log('Fetched payment/package history:', historyData);
                // Merge into existing patient state
                setPatient(prev => ({
                    ...prev,
                    paymentPackageHistory: historyData
                }));
            } catch (historyError) {
                console.warn('Payment/package history not available:', historyError);
                // Do not show error to user; only log
            }

            } catch (error) {
                console.error('Failed to load patient', error);
            } finally {
                setLoadingPatient(false);
            }
        };

        if (id) {
            fetchPatientById();
        }
    }, [id]);


    if (isPatientView) {
        if (loadingPatient) {
            return <div>Loading patient data...</div>;
        }

        if (patient) {
            return (
                <PatientInfoDisplay
                    patient={patient}
                    onBack={() => navigate('/outpatient/appointments')}
                />
            );
        }

        return <div>Patient Info not found.</div>;
    }


    return (
        <PatientsListTable
            onSelectPatient={(patient) => {
                console.log("Selected patient:", patient); // 👈 Log full patient object
                navigate(`/outpatient/patients/patientInfoDisplay/${patient.mrNumber}`, {
                    state: { patient },
                });
            }}
        />

    );
};
export default Patients;
